import { stringify } from "query-string";
import { Redirect } from "react-router-dom";
export function hydrateRoute(routePath, params) {
    const withoutLocale = (routePath || "").replace(/^\/:locale\(.+?\)\?/, "");
    const hydrated = withoutLocale.replace(/:[a-zA-Z]+(\(.+?\))?\??\*?/gi, (part) => {
        const paramName = part.slice(1).replace(/\(.*?\)\??\*?|\?|\*/, "");
        const defaultValue = part.match(/\?$/) ? "" : part;
        return params[paramName] !== undefined ? params[paramName] : defaultValue;
    });

    return params.locale && hydrated.match(/^\//) ? `/${params.locale}${hydrated}` : hydrated;
}

function injectFilters(path, queryParams) {
    if ((queryParams && !queryParams.filter) || !queryParams) {
        return path;
    }
    return `${path}?${stringify({ filter: queryParams.filter })}`;
}

export function createLink(basePath, proxy, item, params, queryParams) {
    if (!((item && item.id && `${item.id}`.length) || (item && item.to && `${item.to}`.length))) {
        return null;
    }
    if (basePath) {
        return injectFilters(`${hydrateRoute(basePath, { ...params })}/${item.id}`, queryParams);
    }
    if (item.to) {
        return injectFilters(hydrateRoute(item.to, { ...params }), queryParams);
    }
    const proxyPath = (proxy || {})[item["__typename"]];
    return injectFilters(hydrateRoute(proxyPath, { ...params, id: item.id }), queryParams);
}

export const deepLink = (links, path, setSelectedLink) => {
    const linksFlattened = flattenNestedLinks(links);
    const candidateLinks = linksFlattened.filter((link) => {
        if (!link.to && !link.matchPaths && !link.matchFn) return false;

        // Check matchFn first — allows arbitrary path matching (e.g. includes("/raw_data"))
        if (link.matchFn && typeof link.matchFn === "function") {
            return link.matchFn(path);
        }

        // Check matchPaths next if available
        if (link.matchPaths) {
            return link.matchPaths.some((mp) => path.startsWith(mp));
        }

        // Check if link.to contains viewMode query param
        const hasViewMode = link.to.includes("viewMode=");

        // If viewMode is present, strip query params for matching (viewMode is routing-related, not filtering)
        // Otherwise, use full link.to to preserve filter logic
        const linkPath = hasViewMode ? link.to.split("?")[0] : link.to;

        return path.startsWith(linkPath);
    });

    const [selectedLink] = candidateLinks.sort((a, b) => {
        // Only strip query params for sorting if viewMode is present
        const aHasViewMode = a.to?.includes("viewMode=");
        const bHasViewMode = b.to?.includes("viewMode=");
        const aPath = aHasViewMode ? (a.to?.split("?")[0] || "") : (a.to || "");
        const bPath = bHasViewMode ? (b.to?.split("?")[0] || "") : (b.to || "");
        // matchFn-only links have no `to` — give them a lower priority than explicit paths
        if (!aPath && a.matchFn) return 1;
        if (!bPath && b.matchFn) return -1;
        return bPath.length - aPath.length;
    });
    if (selectedLink?.id) {
        setSelectedLink(selectedLink.id);
    } else {
        setSelectedLink("");
    }
};

function flattenNestedLinks(linksOriginal) {
    if (linksOriginal && linksOriginal.length > 0) {
        return linksOriginal.reduce((acc, link) => {
            Array.isArray(link.nestedLinks)
                ? acc.push(...flattenNestedLinks(link.nestedLinks))
                : acc.push(link);
            return acc;
        }, []);
    }

    return [];
}

export function urlRedirectLink(linkToRedirect, isToForcePush = false) {
    return isToForcePush ? (
        <Redirect to={`${linkToRedirect}`} push />
    ) : (
        <Redirect to={`${linkToRedirect}`} />
    );
}
